import createHashHistory from 'history/lib/createHashHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createHashHistory);


//////////////////
// WEBPACK FOOTER
// ./~/react-router/es/hashHistory.js
// module id = 736
// module chunks = 3